import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { UpdateCategoriaProductoAction } from "../../actions/categoriaActions/UpdateCategoriaProductoAction";
import { CategoriaCreateInterface } from "../../interfaces/categoriaInterfaces/CategoriaCreate.interface";
import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import { useToast } from "vue-toastification";

const toast = useToast();

interface UpdateCategoriaParams {
  idCategoria: string;
  categoria: CategoriaCreateInterface;
}

export function useCategoriaProductoUpdate(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ idCategoria, categoria }: UpdateCategoriaParams) =>
      UpdateCategoriaProductoAction(idCategoria, categoria),

    onSuccess: async (
      response: ApiResponse<CategoriasProductoInterface>,
      variables
    ) => {
      // Borrar cachÃ© del findOne
      queryClient.removeQueries({
        queryKey: ["CategoriaProductoFindOne", variables.idCategoria],
      });

      //  Refrescar la lista completa
      await queryClient.invalidateQueries({
        queryKey: ["CategoriaProductosList"],
      });

      toast.success("CategorÃ­a actualizada correctamente");

      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al actualizar categorÃ­a");
      if (onClose) onClose();
    },
  });

  return {
    ...mutation,
  };
}
